import React, { useState } from "react";

// Modules
// App

// UI components
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Button, Slider } from "@mui/material";

export default function Transition(props) {
  const transitions = ["none", "fade", "slide", "convex", "concave", "zoom"];

  const transitionSpeeds = [
    {
      value: -1,
      label: "Slower",
    },
    {
      value: 0,
      label: "Default",
    },
    {
      value: 1,
      label: "Faster",
    },
  ];

  const [selectedTransition, setTransition] = useState(
    props.selectedTransition ? props.selectedTransition : transitions[2],
  );
  const [selectedTransitionSpeed, setTransitionSpeed] = useState(
    props.selectedTransitionSpeed
      ? props.selectedTransitionSpeed
      : 0,
  );

  const onSetTransition = (transition) => {
    setTransition(transition);
    props.onTransitionSelected(transition);
  };

  const onSetTransitionSpeed = (transitionSpeed) => {
    console.log(transitionSpeed)
    setTransitionSpeed(transitionSpeed);
    props.onTransitionSpeedSelected(transitionSpeed);
  };

  return (
    <div className="settings-wrap transitions">
      <Row>
        <Col xs="auto">
          <h6 className="ss-subtitle">{props.title}</h6>
        </Col>
      </Row>
      <Row>
        {transitions.map((transition, index) => {
          return (
            <Col
              key={`transition-${index}`}
              className={`transition py-2 transition-${transition} ${transition === selectedTransition ? "selected" : ""}`}
            >
              <Button
                className="btn"
                sx={{ height: "40px", width: "60px", perspective: "400px" }}
                onClick={() => {
                  onSetTransition(transition);
                }}
              >
                <div className="t-slide ts-1">
                  <span>1</span>
                </div>
                <div className="t-slide ts-2">
                  <span>2</span>
                </div>
              </Button>
              <span>{transition}</span>
            </Col>
          );
        })}
      </Row>
      <Row className="d-flex justify-content-center">
        {props.speedSlider && (
          <Col xs={3}>
            <Slider
              className="transition-speed-slider"
              size="small"
              min={-1}
              max={1}
              defaultValue={0}
              step={1}
              value={selectedTransitionSpeed}
              track={false}
              onChange={(changeEvent) =>
                onSetTransitionSpeed(changeEvent.target.value)
              }
              marks={transitionSpeeds}
            />
          </Col>
        )}
      </Row>
    </div>
  );
}
